import React from 'react';
import clsx from 'clsx';
import { ActionButton, Flex, Text, ToggleButton } from '@adobe/react-spectrum';
export const Button = (props) => {
    const { isSelected = false, isToggle = false, Icon = undefined, 'data-test-id': dataTestId, label, onPress, } = props;
    const Btn = isToggle ? ToggleButton : ActionButton;
    const desktopMainViewLayout = configGet('desktopMainViewLayout', 'row');
    return (React.createElement(Btn, { "data-test-id": dataTestId, isSelected: isSelected, onPress: onPress, height: "auto", UNSAFE_className: clsx('sidebar-btn', desktopMainViewLayout), isQuiet: true },
        React.createElement(Flex, { UNSAFE_className: "sidebar_btn--content", direction: "column", alignItems: "center" },
            Icon && (React.createElement(Flex, { alignItems: "center", justifyContent: "center", width: "size-350", height: "size-350" },
                React.createElement(Icon, null))),
            React.createElement(Text, { UNSAFE_className: "sidebar-btn__label spectrum-Body--sizeXS" }, label))));
};
